/** Firestore collection for shoppers in שוק הבסטות (separate from weekly site `users`). */
export const MARKETPLACE_USERS_COLLECTION = 'marketplaceUsers';

export const MARKETPLACE_CUSTOMER_ROLE = 'marketplaceCustomer';
